module.exports = __webpack_public_path__ + "media/audio31.d4eda351.mp3";